import axios from 'axios';
import {API_ORIGEM,AMBIENTE_DESENVOLVIMENTO} from './apiAmbiente';

// Protege chamadas antigas/dinamicas alem das URLs centralizadas nas telas.
// Instalar depois do interceptor de suporte: Axios executa os mais novos primeiro.
if (!axios.__mbAmbienteInstalado) {
  axios.__mbAmbienteInstalado=true;
  axios.interceptors.request.use(config=>{
    const url=new URL(config.url||'',window.location.origin);
    const producao=url.hostname==='api.espacomarciobagagine.com.br';
    const desenvolvimento=url.hostname==='apidesenv.espacomarciobagagine.com.br';
    if (AMBIENTE_DESENVOLVIMENTO&&producao)config.url=API_ORIGEM+url.pathname+url.search;
    if (!AMBIENTE_DESENVOLVIMENTO&&desenvolvimento)throw new Error('A tela de produção não pode acessar a API de desenvolvimento.');
    return config;
  });
}
